<div class="component-viewer">
    <mat-card>
        <mat-card-header style="display: inline;">
            <div class="row w-100">
                <div class="col-6 text-start">
                    <h2 class="mb-0">Prices</h2>
                </div>
                <div class="col-6 text-end">
                    <button mat-raised-button (click)="createBand()">Add <mat-icon>add</mat-icon></button>
                </div>
            </div>
        </mat-card-header>
        <mat-card-content>
            <gt-table *ngIf="true" [loading]="isLoading" [defaultPageSize]="15" [updateFilterEvent]="updateFilterEvent"
            [filter]="filter" [data]="prices" (filterChanged)="getPrices()" (filterReset)="resetFilter()">
        </gt-table>
        <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
        <table mat-table [dataSource]="prices" matSort (matSortChange)="sortData($event)">
            <ng-container matColumnDef="bayNumber">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="bayNumber"> Bay Number </th>
                <td mat-cell *matCellDef="let price"> {{price.bayNumber}} </td>
            </ng-container>
            <ng-container matColumnDef="bayName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="bayName"> Bay Name </th>
                <td mat-cell *matCellDef="let price"> {{price.bayName}} </td>
            </ng-container>
            <ng-container matColumnDef="priceBandName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="priceBandName"> Price Band </th>
                <td mat-cell *matCellDef="let price"> {{price.priceBandName}} ({{price.priceBandDescription}}) </td>
            </ng-container>
            <ng-container matColumnDef="amount">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="amount"> Amount </th>
                <td mat-cell *matCellDef="let price"> ${{price.amount}} </td>
            </ng-container>
            <ng-container matColumnDef="durationMinutes">   
                <th mat-header-cell *matHeaderCellDef mat-sort-header="durationMinutes"> Duration </th>
                <td mat-cell *matCellDef="let price"> {{price.durationMinutes | minutesToHours}} </td>
            </ng-container>
            <ng-container matColumnDef="lastEditedDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="lastEditedDate"> Last Edited Date </th>
                <td mat-cell *matCellDef="let price"> {{price.lastEditedDate | date: 'MMM d, y, h:mm a'}} </td>
            </ng-container>
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let price">
                    <button mat-icon-button [matMenuTriggerFor]="actionsMenu">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #actionsMenu>
                        <button mat-menu-item (click)="edit(price)">
                            Edit <mat-icon>edit</mat-icon>
                        </button>&nbsp;
                        <button mat-menu-item (click)="delete(price)" class="warning">
                            Delete <mat-icon class="warning">delete</mat-icon>
                        </button>
                    </mat-menu>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        </mat-card-content>
    </mat-card>
</div>